export default {
  platformNotice: {
    receiver: "接收平台",
    title: "公告标题",
    content: "公告内容描述",
    type: "展示位置",
    type0: "首页",
    status: "状态",
    status0: "待发送",
    status1: "已发送",
    status2: "草稿",
    startTime: "发送时间",
    updateTime: "更新时间",
    updateUserName: "操作人",
    messageWithdraw: "是否撤回",
    messageSend: "是否立即发送",
    remark: "备注",
    detail: "详情",
    tip: {
      receiver: "请选择接收平台",
      type: "请选择展示位置",
      title: "请输入1-100个字符",
      content: "请输入1-2000个字符",
      startTime: "请选择发送时间",
      remark: "请输入1-200个字符",
    }
  }
}
